import {DataItemComponent} from './data-item.component';

export const DATA_ITEM_COMPONENTS = [
    DataItemComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/data-item/index.ts